import { __decorate, __metadata } from "tslib";
import { Component, Input } from 'angular-ts-decorators';
import template from './coveo-analytics-wrapper.html';
import { getWebStoreApiClient } from '@gn-audio/core/auth/web-store-api/client';
import { getEmailFromAccount } from '@gn-audio/core/auth/uip/utilities';
var CoveoAnalyticsWrapperComponent = (function () {
    function CoveoAnalyticsWrapperComponent() {
        this.authorizedUserEmail = this.getAuthorizedUserEmail();
    }
    CoveoAnalyticsWrapperComponent.prototype.getAuthorizedUserEmail = function () {
        var account = getWebStoreApiClient().account;
        if (!account) {
            return '';
        }
        return getEmailFromAccount(account);
    };
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], CoveoAnalyticsWrapperComponent.prototype, "accessToken", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], CoveoAnalyticsWrapperComponent.prototype, "organizationId", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], CoveoAnalyticsWrapperComponent.prototype, "coveoUserAnalyticsUrl", void 0);
    CoveoAnalyticsWrapperComponent = __decorate([
        Component({
            selector: 'coveoAnalyticsWrapper',
            template: template,
        }),
        __metadata("design:paramtypes", [])
    ], CoveoAnalyticsWrapperComponent);
    return CoveoAnalyticsWrapperComponent;
}());
export { CoveoAnalyticsWrapperComponent };
